<template>
  <div class="wrapper">
    <AdminBreadCrumb title="キャンペーン管理" />
    <CampaignList
      :loading="loading"
      :incompleteCampaingList="incompleteCampaingList"
      @submit="setComplete"
    />
  </div>
</template>

<script>
import { accountInitializer } from '@/mixins/accountInitializer'
import { setDrawerTypeAdmin } from '@/mixins/setDrawerTypeAdmin'
import { setToolBarTypeAdmin } from '@/mixins/setToolBarTypeAdmin'
import CampaignList from '@/components/Admin/Campaign/CampaignList'
import AdminBreadCrumb from '@/components/Shared/BreadCrumb/AdminBreadCrumb'
import { actions, getters } from '@/vuex/modules/admin/campaign/constants'
import {
  actions as snackbarActions,
  snackbarType,
} from '@/vuex/modules/ui/snackbar/constants'

export default {
  components: { CampaignList, AdminBreadCrumb },
  mixins: [accountInitializer, setDrawerTypeAdmin, setToolBarTypeAdmin],
  computed: {
    loading() {
      return this.$store.getters[getters.loading]
    },
    incompleteCampaingList() {
      return this.$store.getters[getters.incompleteCampaignList]
    },
  },
  methods: {
    setComplete(campaign) {
      try {
        this.$store.dispatch(actions.SET_COMPLETE, { id: campaign.id })

        this.$store.dispatch(snackbarActions.SHOW_SNACKBAR, {
          type: snackbarType.SUCCESS,
          message: '入稿を完了しました',
        })

        this.$store.dispatch(actions.DELETE_CAMPAIGN, {
          campaign: campaign,
          incompleteCampaingList: this.incompleteCampaingList,
        })
      } catch (e) {
        const error = new Error('入稿に失敗しました。')
        throw error
      }
    },
  },
}
</script>

<style scoped>
.wrapper {
  width: 100%;
}
</style>
